import {
  Form, FormSubmitType, Spacing, SpacingName, TypographyName,
} from '@doveit/lego';
import merge from 'lodash.merge';
import React from 'react';
import { FormFieldsConfig } from '../../types';
import contactFormSchema from './IntentForm.schema';
import defaultFieldsConfig from './fieldsPreset';
import PrivacyPolicyFooter from '../privacy-policy-footer/PrivacyPolicyFooter';

export interface IntentFormModel {
  id: string,
  name: string,
  email: string,
  phoneNumber: string,
  marketing?: boolean,
  thirdParties?: boolean,
}

export interface IntentFormProps {
  initialValues?: Partial<IntentFormModel>,
  fields?: FormFieldsConfig,
  loading?: boolean,
  errorMessage?: string,
  successMessage?: string,
  dataRef?: string,
  onSubmit: FormSubmitType<IntentFormModel>,
}

const IntentForm: React.FC<IntentFormProps> = ({
  initialValues = {},
  onSubmit,
  fields = {},
  loading,
  errorMessage,
  successMessage,
  dataRef,
}) => {
  const initialValuesMerged: IntentFormModel = {
    id: '',
    name: '',
    email: '',
    phoneNumber: '',
    ...initialValues,
  };

  const fieldsMerged = merge({}, defaultFieldsConfig, fields);

  return (
    <Form
      initialValues={initialValuesMerged}
      onSubmit={onSubmit}
      validationSchema={contactFormSchema}
      compact
      loading={loading}
      dataRef={dataRef}
    >
      {!fieldsMerged.name.hidden && (
        <Form.Item>
          <Form.Input
            name="name"
            placeholder={fieldsMerged.name.placeholder}
            aria-label={fieldsMerged.name.ariaLabel}
            label={fieldsMerged.name.label}
            required={fieldsMerged.name.required}
          />
        </Form.Item>
      )}
      {!fieldsMerged.phoneNumber.hidden && (
        <Form.Item>
          <Form.Input
            type="tel"
            name="phoneNumber"
            placeholder={fieldsMerged.phoneNumber.placeholder}
            aria-label={fieldsMerged.phoneNumber.ariaLabel}
            label={fieldsMerged.phoneNumber.label}
            required={fieldsMerged.phoneNumber.required}
          />
        </Form.Item>
      )}
      {!fieldsMerged.email.hidden && (
        <Form.Item>
          <Form.Input
            type="email"
            name="email"
            placeholder={fieldsMerged.email.placeholder}
            aria-label={fieldsMerged.email.ariaLabel}
            label={fieldsMerged.email.label}
            required={fieldsMerged.email.required}
          />
        </Form.Item>
      )}

      <Form.Item>
        <Form.Checkbox
          name="marketing"
          aria-label={fieldsMerged.marketing.ariaLabel}
          text={fieldsMerged.marketing.text}
          textSize={TypographyName.SMALLER}
        />
        <Form.Checkbox
          name="thirdParties"
          aria-label={fieldsMerged.thirdParties.ariaLabel}
          text={fieldsMerged.thirdParties.text}
          textSize={TypographyName.SMALLER}
        />
      </Form.Item>

      <Form.Item>
        <Form.Submit
          label={fieldsMerged.button.label}
          aria-label={fieldsMerged.button.ariaLabel}
          expanded
        />
        <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
          <PrivacyPolicyFooter />
        </Spacing>
      </Form.Item>

      {errorMessage && (
        <Form.Item>
          <Form.ErrorMessage message={errorMessage} />
        </Form.Item>
      )}

      {successMessage && (
        <Form.Item>
          <Form.SuccessMessage message={successMessage} />
        </Form.Item>
      )}
    </Form>
  );
};

export default IntentForm;
